export const systemFieldConfig = {
    SFDC: [
      { title: "SC ID", path: "SCResponse.userId" },
      { title: "SFDC ID", path: "SFDCContactAPI.id" },
    ],
    SFDCEval: [
        { title: "SFDCEval ID", path: "SFDCEval.id" },
        
      ],
    AppHUB: [
      { title: "AppHUB", path: "transactionId1" },
      
    ],
    IDM: [
      { title: "NLP", path: "transactionId" },
    ],
    NGCCreateEval: [
        { title: "NGCCreateOrg", path: "NGCCreateOrgResponseEval" },
        { title: "NGCResponse", path: "NGCResponseEval.id" },
      ],
      EMS: [
        { title: "EMS", path: "entitlementStatus[0].eid" },
   
      ],
      NGCEnablement: [
        { title: "NGCEnablement", path: "Status" },
   
      ],
      NGCUpdateORG: [
        { title: "NGCUpdateORG", path: "NGCUpdateOrgResponse" },
   
      ],
      EMSCreate: [
        { title: "EMSCreate", path: "entitlementStatus[0].eid" },
   
      ],
      LGS: [
        { title: "LGS", path: "APIResponse" },
   
      ],
    
  };
  
  export const getValueFromPath = (obj, path) => {
    if (!obj || typeof path !== "string") return undefined;
  
    const parts = path.split(".");
  
    let current = obj;
  
    for (let i = 0; i < parts.length; i++) {
      const part = parts[i];
  
      // Match key and optional array index like "entStatus[0]"
      const match = part.match(/^([a-zA-Z0-9_$]+)(\[(\d+)\])?$/);
  
      if (!match) return undefined;
  
      const key = match[1];
      const index = match[3];
  
      if (current === null || current === undefined || typeof current !== "object") {
        return undefined;
      }
  
      current = current[key];
  
      if (index !== undefined) {
        if (!Array.isArray(current)) return undefined;
        current = current[parseInt(index, 10)];
      }
    }
  
    return current;
  };
  
  
  